import { render, staticRenderFns } from "./addReference.vue?vue&type=template&id=4f4fa562&scoped=true&"
import script from "./addReference.vue?vue&type=script&lang=js&"
export * from "./addReference.vue?vue&type=script&lang=js&"
import style0 from "./addReference.vue?vue&type=style&index=0&id=4f4fa562&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4fa562",
  null
  
)

export default component.exports